/**
 * Copy for the TasteMatch badge's "no personal TasteMatch" state.
 *
 * CD decision (2026-10-04, clarified same day): a restaurant with no personal
 * TasteMatch reads "Unsure TasteMatch", always, whether or not a public/Google
 * rating exists. ("Unsure" and "Not enough data" were briefly two candidate
 * names for this one state; CD settled on "Unsure TasteMatch".) Read by every
 * surface that names the state: the card/list/Surprise Me/hero badges (the
 * tier word through `NOT_SURE_RATING_EMOJI` in `restaurantUtils.tsx`, the full
 * label through `getRestaurantPillLabelProps`) and the map's Pin Key
 * (`mapPinKey.ts`).
 *
 * Trademark convention (same as the tier pills, see `TasteMatchPill` and
 * `compatibilityModal.ts`): "TasteMatch" is a noun, so the tier word is an
 * adjective in front of it ("High TasteMatch", "Unsure TasteMatch"). The badge
 * pill appends the ™ ("Unsure TasteMatch™", like "High TasteMatch™"); running
 * copy such as the Pin Key carries the ™ only on its first TasteMatch mention,
 * so `label` here is stored without it.
 *
 * Deliberately dependency-free so `restaurantUtils.tsx` and `mapPinKey.ts` can
 * both import it without a cycle.
 */
/**
 * The 🤔 character drawn on the grey "Unsure TasteMatch" map pins and the Pin
 * Key. Re-exported from `restaurantUtils.tsx` for existing importers.
 */
export const NOT_SURE_EMOJI_CHAR = '\u{1F914}'; // 🤔

export const tasteMatchBadgeCopy = {
  /** Tier word for no personal TasteMatch; the same slot "High"/"Low" fill. */
  tierWord: 'Unsure',
  /** Full state label, no trademark glyph (the pill adds ™, the Pin Key does not). */
  label: 'Unsure TasteMatch',
} as const;
